import { Reports } from "@graylog/enterprise-api";
import i18n from "i18n";
import fetchReports from "report/logic/fetchReports";
const isDashboardPageUsedInReports = async (dashboardId, queryId, widgetIds) => {
  const reports = await fetchReports();
  const reportIds = await Reports.byWidgetIds(dashboardId, widgetIds[queryId]);
  if ((reportIds == null ? void 0 : reportIds.length) === 1) {
    const reportId = reportIds[0];
    const inaccessibleReport = !reports[reportId];
    const reportTitle = inaccessibleReport ? reportId : `"${reports[reportId].title}"`;
    return window.confirm(
      i18n.t(
        inaccessibleReport ? "notifications.dashboard_page_single_inaccessible" : "notifications.dashboard_page_single",
        { ns: "enterprise_report", report_title: reportTitle }
      )
    );
  }
  if ((reportIds == null ? void 0 : reportIds.length) > 1) {
    const reportTitles = reportIds.map((reportId) => {
      const inAccessibleReport = !reports[reportId];
      const reportTitle = inAccessibleReport ? reportId : `"${reports[reportId].title}"`;
      const notPermittedSuffix = inAccessibleReport ? i18n.t("notifications.report_not_permitted_title", { ns: "enterprise_report" }) : "";
      return `    - ${reportTitle}${notPermittedSuffix}`;
    }).join("\n");
    return window.confirm(
      i18n.t("notifications.dashboard_page_multiple", { ns: "enterprise_report", report_titles: reportTitles })
    );
  }
  return null;
};
export default isDashboardPageUsedInReports;
